import { Notification } from '@thanx/uikit/notification'
import { Text } from '@thanx/uikit/text'
import Information from 'components/Icons/Information'
import PageHeader from 'components/PageHeader'
import SearchablePaginatedContent from 'components/SearchablePaginatedContent'
import CreateListModal from 'containers/userLists/landing/CreateListModal.container'
import ListCardRow from 'containers/userLists/landing/ListCardRow.container'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import { useDispatch } from 'react-redux'
import { openCreateModal } from 'slices/userLists'

import { useUserListSearch } from './hooks'

const t = buildTranslate('user_lists.landing')
const tBanner = buildTranslate('user_lists.self_serve_banner')
const tHow = buildTranslate('user_lists.how_it_works')
const tRoot = buildTranslate('user_lists')

const Landing: React.FC = () => {
  const dispatch = useDispatch()
  const {
    lists,
    isLoading,
    pagination,
    totalCount,
    handleSearchChange,
    handlePageChange,
  } = useUserListSearch()

  const handleCreate = () => {
    dispatch(openCreateModal())
  }

  const hasNoLists = !isLoading && totalCount === 0

  return (
    <PageHeader
      title={t('title')}
      description={t('description')}
      buttonText={t('button')}
      buttonAction={handleCreate}
      learnMoreUrl={tRoot('help_article_url')}
    >
      <div className="grey-05-bkg border-top-1 grey-20-border">
        <Container className="py-l">
          <div className="mb-l">
            <Notification kind="info" size="full">
              <div className="d-flex p-xs align-items-start">
                <span className="mr-s mt-xxs flex-shrink-0">
                  <Information type="info" />
                </span>
                <div>
                  <Text.BodyText4 tag="p" bold className="mb-xxs">
                    {tBanner('title')}
                  </Text.BodyText4>
                  <Text.BodyText4 tag="p" color="grey70" className="mb-0">
                    {tBanner('body')}
                  </Text.BodyText4>
                  <a
                    href={tRoot('help_article_url')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-inline-block mt-xs"
                  >
                    <Text.BodyText4 bold color="primary">
                      {tBanner('learn_more')}
                    </Text.BodyText4>
                  </a>
                </div>
              </div>
            </Notification>
          </div>
          {hasNoLists && (
            <div
              className="d-flex p-l mb-l border-radius-5 align-items-start"
              style={{ backgroundColor: '#F0F4F8' }}
            >
              <span className="mr-s mt-xxs flex-shrink-0" aria-hidden="true">
                💡
              </span>
              <div>
                <Text.BodyText4
                  tag="p"
                  bold
                  className="text-uppercase letter-spacing-1 mb-s"
                >
                  {tHow('title')}
                </Text.BodyText4>
                <Text.BodyText4 tag="p" color="grey70" className="mb-s">
                  {tHow('description')}
                </Text.BodyText4>
                <ul className="mb-0 pl-l">
                  <li>
                    <Text.BodyText4 color="grey70">
                      {tHow('step_1')}
                    </Text.BodyText4>
                  </li>
                  <li>
                    <Text.BodyText4 color="grey70">
                      {tHow('step_2')}
                    </Text.BodyText4>
                  </li>
                  <li>
                    <Text.BodyText4 color="grey70">
                      {tHow('step_3')}
                    </Text.BodyText4>
                  </li>
                </ul>
              </div>
            </div>
          )}
          <SearchablePaginatedContent
            contentIsLoading={isLoading}
            onChangePage={handlePageChange}
            onChangeSearchInput={handleSearchChange}
            currentPage={pagination?.current_page || 1}
            numberOfPages={pagination?.total_pages || 0}
            searchPlaceholder={t('search_placeholder')}
          >
            <div className="d-flex flex-column" style={{ gap: '16px' }}>
              {lists.map(list => (
                <ListCardRow key={list.id} list={list} />
              ))}
            </div>
          </SearchablePaginatedContent>
        </Container>
      </div>
      <CreateListModal />
    </PageHeader>
  )
}

export default Landing
